up.compiler(".up_blog", function (element) {
  const sommaire = element.querySelector(".js-sommaire");
  const content = element.querySelector(".js-content");
  const olElement = sommaire.querySelector("ol");
  const titles = content.querySelectorAll("h2");
  const paragraphs = content.querySelectorAll("p");

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
  }

  paragraphs.forEach((paragraph) => {
    const text = paragraph.textContent.trim();

    // Si le texte commence par <script, on le traite
    if (text.startsWith("<script") > 0) {
      // Créer un élément DOM temporaire pour parser le texte
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = text; // Ceci va créer un vrai élément <script>

      const scriptTag = tempDiv.firstElementChild;

      // Remplacer le paragraphe par le vrai script
      if (scriptTag && scriptTag.tagName === "SCRIPT") {
        const newScript = document.createElement("script");

        // Copier les attributs
        for (let attr of scriptTag.attributes) {
          newScript.setAttribute(attr.name, attr.value);
        }

        // Optionnel : copier le contenu du script (s'il y a du inline)
        newScript.textContent = scriptTag.textContent;

        // Remplacer le <p> par le <script>
        paragraph.replaceWith(newScript);
      }
    }
  });
  titles.forEach((title) => {
    const text = title.textContent.trim();
    const slug = slugify(text);

    title.setAttribute("id", slug);

    const liElement = document.createElement("li");
    liElement.innerHTML = `<a class="js-sommairelinks hover:underline" href="#${slug}">${text}</a>`;
    olElement.appendChild(liElement);

    const sommaireLinks = sommaire.querySelectorAll(".js-sommairelinks");

    sommaireLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();

        const targetId = link.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const offset = -90;
          const targetPosition =
            targetElement.getBoundingClientRect().top + window.scrollY + offset;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }
      });
    });
  });
});
